import IncludedBaggage from './components/IncludedBaggage.css';

export default {
	IncludedBaggage
};
